import React, { useEffect, useRef } from "react";
import styles from './OwnLogs.module.scss'

export function formatOwnLog(message, type) {
}

function OwnLogs({logs}) {

    const container = useRef();

    useEffect(() => {
        container?.current?.scroll({ top: container?.current?.scrollHeight, behavior: 'smooth' });
    }, [logs]);

    const padTo2Digits = num => String(num).padStart(2, '0');
    const getTimestamp = timestamp => {
        const time = new Date(timestamp);
        return `${padTo2Digits(time.getHours())}:${padTo2Digits(time.getMinutes())}:${padTo2Digits(time.getSeconds())}`
    }

    return (
        <div className={styles.logs}>
            <div className={styles.logs__container} ref={container}>
                {
                    logs.map((log, index) => {
                        let color = '';

                        if (log.type === 'success') color = `var(--colorFontSuccess)`;
                        if (log.type === 'warning') color = `var(--colorFontWarning)`;
                        if (log.type === 'error') color = `var(--colorFontError)`;
                        if (log.type === 'info') color = `var(--colorFontInfo)`;

                        return (
                            <div
                                className={styles.log}
                                style={{'--own-log-color' : color}}
                                key={index}
                            >
                                <p className={styles.log__group}>{log.group}</p>
                                <p className={styles.log__separator}>-</p>
                                <p className={styles.log__message}>{log.message}</p>
                                <p className={styles.log__timestamp}>{getTimestamp(log.timestamp)}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default OwnLogs